<template>
    <Path>
        <template v-slot:path>
            <li><router-link :to="{name: 'dashboard'}" >الصفحة الرئيسية</router-link> </li>
            <li> <span class="divider"> / </span><a href="#"> السجل المدني الذكي </a> </li>      
        </template>
    </Path>

    <section>
        <div class="py-4 ">
            <div class="container">
                <div class="row">
                    <div class="col-12 mb-2 ">                    
                        <h1 class="blueFont py-3">السجل المدني الذكي</h1>                          
                        <p>
                            يشهد قطاع الأحوال المدنية تطوراً ملحوظاً فى مجال الخدمات المقدمة للمواطنين، وعليه فقد تم تفعيل ماكينة (السجل الذكى) بمقر ديوان القطاع والمزودة بخاصية التحصيل النقدى, والتى يمكن للمواطن من خلالها ودون تدخل العنصر البشرى من الحصول على أى من مصدرات القطاع المميكنة مثل شهادات ( الميلاد / الوفاة / الزواج / الطلاق ) وذلـك عــــــن طريق إختيار نوع المصدر المطلوب إستخراجه من خلال شاشتها التلامسية عقب تحققها من هويته من خلال مطابقة بصمة (الوجه – أحد الأصابع) مع ما هو مسجل عنه بقاعدة بيانات الرقم القومى البايومترية
                        </p>             
                        <img src="@/assets/images/smartrecord.jpg" alt="" class="img-fluid py-3">        
                    </div>                                  
                </div>
            </div>
        </div>
        
    </section>

</template>

<script>
import Path from '@/components/Path.vue'
  export default {
   name: 'SmartComp',
   components:{Path}
  }
</script>